import { render, staticRenderFns } from "./MemoField.vue?vue&type=template&id=d4574b16&scoped=true&"
import script from "./MemoField.vue?vue&type=script&lang=js&"
export * from "./MemoField.vue?vue&type=script&lang=js&"
import style0 from "./MemoField.vue?vue&type=style&index=0&id=d4574b16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4574b16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
